import { put, call, fork, takeEvery, all } from 'redux-saga/effects';
import { reset as resetForm } from 'redux-form';

import * as profileModule from '../modules/profile.module';
import * as Api from '../../core/api';

export function* updateAccount({ payload: data }) {
  const { response, error } = yield call(Api.profile.updateAccount, data);

  if (response) {
    yield put(profileModule.updateAccountSuccess(data));
  } else {
    yield put(profileModule.updateAccountFail(error));
  }
}
export function* watchUpdateAccount() {
  yield takeEvery(profileModule.updateAccount.getType(), updateAccount);
}

export function* updatePassword({ payload: { oldPassword, newPassword } }) {
  const { response, error } = yield call(Api.profile.updatePassword, { oldPassword, newPassword });

  if (response) {
    yield put(profileModule.updatePasswordSuccess());
    yield put(resetForm('profile.password'));
  } else {
    yield put(profileModule.updatePasswordFail(error));
  }
}
export function* watchUpdatePassword() {
  yield takeEvery(profileModule.updatePassword.getType(), updatePassword);
}

export function* updatePublisherCompanyInfo({ payload: data }) {
  const { response, error } = yield call(Api.profile.updatePublisherCompanyInfo, data);

  if (response) {
    yield put(profileModule.updatePublisherCompanyInfoSuccess(data));
  } else {
    yield put(profileModule.updatePublisherCompanyInfoFail(error));
  }
}
export function* watchUpdatePublisherCompanyInfo() {
  yield takeEvery(profileModule.updatePublisherCompanyInfo.getType(), updatePublisherCompanyInfo);
}

export function* updatePaymentInfo({ payload: data }) {
  const { response, error } = yield call(Api.profile.updatePaymentInfo, data);

  if (response) {
    yield put(profileModule.updatePaymentInfoSuccess(data));
  } else {
    yield put(profileModule.updatePaymentInfoFail(error));
  }
}
export function* watchUpdatePaymentInfo() {
  yield takeEvery(profileModule.updatePaymentInfo.getType(), updatePaymentInfo);
}

export default function* watchProfile() {
  return yield all([
    fork(watchUpdateAccount),
    fork(watchUpdatePassword),
    fork(watchUpdatePublisherCompanyInfo),
    fork(watchUpdatePaymentInfo),
  ]);
}



/** WEBPACK FOOTER **
 ** ./js/redux/saga/profile.saga.js
 **/